import { z } from "zod";

// The credit inputs are text inputs masked by JustDecimal, so they hand over a
// string: coerce it. PO credits are fractional (decimal(10,2) in the backend),
// capped at 2 decimals — the backend rejects more with a 400.
const MAX_DECIMALS_MESSAGE = "deve ter no máximo 2 casas decimais";

export const PoContractsUpsellSchema = z.object({
  upsellOption: z.coerce
    .number()
    .min(1, "Opção de upsell deve ser no mínimo 1")
    .multipleOf(0.01, `Opção de upsell ${MAX_DECIMALS_MESSAGE}`),
  upsellProRataOption: z.coerce
    .number()
    .min(1, "Opção de pro rata deve ser no mínimo 1")
    .multipleOf(0.01, `Opção de pro rata ${MAX_DECIMALS_MESSAGE}`)
    .optional(),
});

export type PoContractsUpsellFormData = z.infer<typeof PoContractsUpsellSchema>;
